export default {
  Home: 'Maison',
  Mobile: 'Mobile',
  Work: 'Travailler',
  Fax: 'Fax',
  Other: 'Autre',
  'Program TFN': 'Programme TFN',
  Business: 'Entreprise',
  Primary: 'Primaire'
};
